import { React, } from 'react';
import { Alert, Button } from 'react-bootstrap'
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import MainPage from './MainPage';

// Main App Starting Point
const App = () => {

  return (
    <div className='app'>
      <Routes>
        <Route path="/" element={<MainPage />} />
      </Routes>
    </div>
  );

}

export default App;
